export class CCStyling {
  public css: {
    [key: string]: string;
  };
  public override: boolean = false;
  constructor() {
    this.css = {};
  }
  public static fromObject(
    obj: { [key: string]: string },
    override: boolean = false
  ): CCStyling {
    const styling = new CCStyling();
    styling.override = override;
    Object.entries(obj).forEach(([k, v]) => {
      if (Boolean(k) && Boolean(v)) {
        styling.setProperty(k, v);
      }
    });
    return styling;
  }
  public static fromArray(
    array: (string | undefined)[],
    override: boolean = false
  ): CCStyling {
    const styling = new CCStyling();
    styling.override = override;
    array.map((item) => {
      if (Boolean(item) && item.includes(":")) {
        const split = item.split(":");
        if (split.length === 2) {
          styling.setProperty(split[0], split[1]);
        }
      }
    });
    return styling;
  }
  public static join(...styles: CCStyling[]): CCStyling {
    const styling = new CCStyling();
    styles.filter(Boolean).forEach((style) => {
      if (style.override) {
        styling.css = style.css;
      } else {
        Object.entries(style.css).forEach(([k, v]) => {
          styling.setProperty(k, v);
        });
      }
    });
    return styling;
  }
  public setProperty(property: string, value: string): void {
    this.css[property] = value;
  }
  public compile(): string {
    return Object.entries(this.css)
      .map(([k, v]) => (Boolean(k) && Boolean(v) ? `${k}:${v}` : ""))
      .filter(Boolean)
      .join(";");
  }
}

// Some commonly used styling
export class DefaultStyling {
  public static blank = CCStyling.fromObject({});
  public static button = CCStyling.fromObject({
    "margin-right": "15px"
  });
  public static genericIcon = CCStyling.fromObject({
    "margin-right": "5px",
    cursor: "pointer"
  });
  public static pointer = CCStyling.fromObject({
    cursor: "pointer"
  });
  public static text = CCStyling.fromObject({
    width: "300px",
    display: "inline-block",
    "margin-right": "10px"
  });
  public static inputText = CCStyling.fromObject({
    width: "min(1020px, 100%)",
    display: "inline-block"
  });
  public static header = CCStyling.fromObject({
    "margin-bottom": "10px",
    "margin-top": "20px",
    "font-weight": "bold",
    "text-decoration": "underline"
  });
  public static bold = CCStyling.fromObject({
    "font-weight": "bold"
  });
  public static wrapper = CCStyling.fromObject({
    "margin-bottom": "5px",
    display: "inline-block",
    width: "100%"
  });
  public static input = CCStyling.fromObject({
    width: "200px",
    display: "inline-block"
  });
  public static String = DefaultStyling.input;
  public static Date = DefaultStyling.input;
  public static Float = DefaultStyling.input;
  public static Integer = DefaultStyling.input;
  public static Check = CCStyling.fromObject({
    display: "inline-block",
    width: "auto",
    height: "auto",
    "margin-right": "10px"
  });
  public static RadioDiv = CCStyling.fromObject({
    padding: "6px",
    width: "min(1020px, 100%)"
  });
  public static RadioInput = CCStyling.fromObject({
    "margin-right": "10px"
  });
  public static RadioLabel = CCStyling.fromObject({
    "font-weight": "initial"
  });
  public static Paragraph = CCStyling.fromObject({
    width: "min(1020px, 100%)",
    display: "inline-block",
    resize: "vertical",
    "min-height": "10rem",
    overflow: "scroll"
  });
  public static Select = CCStyling.fromObject({
    width: "auto",
    display: "inline-block"
  });
  public static table = CCStyling.fromObject({
    border: "1px solid #DDDDDD",
    "border-collapse": "collapse",
    width: "100%"
  });
  public static thead = CCStyling.fromObject({
    background: "#DDDDDD"
  });
  public static tfoot = CCStyling.fromObject({
    "text-align": "center",
    cursor: "pointer",
    border: "1px solid #DDDDDD"
  });
  public static removeRowButton = CCStyling.fromObject({
    padding: "5px",
    width: "0px"
  });
  public static note = CCStyling.fromObject({
    "margin-top": "5px"
  });
  public static careerYear = CCStyling.fromObject(
    {
      "margin-right": "15px",
      display: "inline-block",
      "margin-top": "7px",
      "vertical-align": "top"
    },
    true
  );
  public static grid = CCStyling.fromObject({
    display: "grid",
    gap: "1rem 5rem"
  });
  public static instructions = CCStyling.fromObject({
    "margin-bottom": "10px",
    "margin-top": "5px"
  });
  public static hyperlink = CCStyling.fromObject({});
}
